import gql from 'graphql-tag';
import { ORGANIZATION_TYPE } from './OrganizationType.gql';

export const ORGANIZATION_TYPE_CONNECTION = gql`
  ${ORGANIZATION_TYPE}
  fragment OrganizationTypeConnection on OrganizationTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...OrganizationType
      }
    }
    totalCount
    edgeCount
  }
`;
